import { initAnalytics } from './lib/analytics';
import { captureError, initSentry } from './lib/sentry';

document.documentElement.setAttribute('data-version', __APP_VERSION__.sha);
// Intentional startup banner so the deployed build sha is visible in the console.
// eslint-disable-next-line no-console
console.info('[PoseDraw] version', __APP_VERSION__);

initSentry();
initAnalytics();

// Handle stale asset errors after deployments — when a user's cached HTML
// references JS/CSS files that no longer exist on the server.
// If the app is already running, show a toast. If it happens during bootstrap
// before the toast handler is registered, reload to get fresh assets.
let hasShownUpdateToast = false;
window.addEventListener('vite:preloadError', (event) => {
  if (hasShownUpdateToast) return;
  hasShownUpdateToast = true;
  if (window.__showUpdateToast) {
    if (event.cancelable) event.preventDefault();
    window.__showUpdateToast();
  } else {
    // Preload error during bootstrap — toast handler not yet available.
    // Reload once to pick up fresh assets instead of leaving a blank page.
    // Guard with sessionStorage to avoid infinite reload if assets are still broken.
    try {
      if (!sessionStorage.getItem('preload_reload')) {
        sessionStorage.setItem('preload_reload', '1');
        window.location.reload();
      }
    } catch {
      // sessionStorage unavailable (e.g. Safari private mode) — reload without guard
      window.location.reload();
    }
  }
});

import('./bootstrap').then(() => {
  try { sessionStorage.removeItem('preload_reload'); } catch { /* noop */ }
}).catch((error) => {
  if (hasShownUpdateToast) return;
  console.error('Failed to bootstrap app', error);
  captureError(error, { tags: { operation: 'bootstrap' } });
});
